import GeoJSON from 'ol/format/GeoJSON.js';
import type Feature from 'ol/Feature.js';
import type Geometry from 'ol/geom/Geometry.js';
import { registerSjtskProjection, EPSG_5514 } from './parcel-map-crs.js';

/**
 * Krok M1 — `GET .../cases/:id/geometry.geojson` vraci GeoJSON uz v 5514
 * (server nic neprevadi, viz `dd-map-tools.ts`), takze `dataProjection` a
 * `featureProjection` jsou tady STEJNE - zadna reprojekce, jen parsovani.
 * Prevod je pritom povinny krok: OL vrstvy neumi kreslit syrovy GeoJSON,
 * potrebuji `ol/Feature` instance.
 */

export interface CaseGeometryFeatureJson {
  readonly type: 'Feature';
  readonly geometry: unknown;
  readonly properties: {
    readonly label: string | null;
    readonly source: string;
    readonly version: number;
    readonly areaM2: number | null;
  };
}

export interface CaseGeometryCollectionJson {
  readonly type: 'FeatureCollection';
  readonly features: readonly CaseGeometryFeatureJson[];
}

let format: GeoJSON | undefined;

function geoJsonFormat(): GeoJSON {
  registerSjtskProjection();
  format ??= new GeoJSON({ dataProjection: EPSG_5514, featureProjection: EPSG_5514 });
  return format;
}

/** GeoJSON FeatureCollection (5514) -> pole `ol/Feature` pro vektorovou vrstvu. */
export function geoJsonToParcelFeatures(collection: CaseGeometryCollectionJson): Feature<Geometry>[] {
  return geoJsonFormat().readFeatures(collection) as Feature<Geometry>[];
}
